import { Box } from '@mui/material';

import { Icon } from './Icon';

import { tx } from '@/theme/tokens';

// A 20px rounded square: a debossed well when off, flat lime with a dark tick when on
const Box20 = ({ checked, indeterminate }: { checked?: boolean; indeterminate?: boolean }) => (
  <Box
    component="span"
    sx={{
      width: 20,
      height: 20,
      borderRadius: '6px',
      display: 'grid',
      placeItems: 'center',
      flex: 'none',
      color: tx.onLime,
      backgroundColor: checked || indeterminate ? tx.lime : tx.fill2,
      boxShadow: checked || indeterminate ? 'none' : tx.deboss,
      transition: `background-color ${tx.ease} .15s`,
    }}>
    {checked && <Icon name="check" size={12} stroke={2.6} />}
    {indeterminate && <Icon name="minus" size={12} stroke={2.6} />}
  </Box>
);

export const CheckboxCheckedIcon = () => <Box20 checked />;
export const CheckboxUncheckedIcon = () => <Box20 />;
export const CheckboxIndeterminateIcon = () => <Box20 indeterminate />;

export const checkboxCheckedIcon = CheckboxCheckedIcon();
export const checkboxUncheckedIcon = CheckboxUncheckedIcon();
export const checkboxIndeterminateIcon = CheckboxIndeterminateIcon();
